<template>
  <div>
    
    <div style="margin-top: 50px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
        <div 
            style="margin-top: 50px; display: flex; 
            flex-direction: column; 
            width: 400px; 
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); 
            padding: 20px;
            justify-content: center; align-items: center;">

                <img alt="Easy Tailor App Logo" src="../../../assets/eta.png" style="width: 150px; ">

                <div style="margin-top: 50px; display: flex; flex-direction: column; width: 80%;  justify-content: flex-start; align-items: flex-start;">

                    <div style="text-align: left;">
                        <b>We have emailed you a 6 digit verification code. Please check your Spam/Junk folder if the email is not found in your Inbox.</b>
                    </div>
                    <br><br>
                    <span type="label">6 Digit Verification Code</span>
                    <el-input @focus="$event.target.select()"
                        v-model="$store.state.signup.props.confirmation_code">
                    </el-input>
                    
                </div>
                
                <div style="margin-top: 20px; display: flex; flex-direction: row; width: 80%;  justify-content: space-between; align-items: space-between;">
                    <el-button :loading="$store.getters.getLoadingState" @click="checkTenantConfirmationCode" type="primary" size="small">Submit</el-button>
                    <el-link @click="$router.push('/signup')">Go Back</el-link>
                        
                </div>

        </div>
    </div>
        
  </div>
</template>

<script>
export default {
    data() {
        return {
            processing: false
        }
    },
    computed: {
        isProcessing() {
            return this.processing
        }
    },
    methods: {
        async checkTenantConfirmationCode() {
            
            if(this.$store.state.signup.props.confirmation_code.length === 0) {
                this.$store.commit('displayMessageAlert', {message: 'Confirmation code is not valid', type: 'Error'})    
                return
            }

            this.processing = true

            await this.$store.dispatch('checkTenantConfirmationCode', {
              id: this.$store.state.signup.props.id,
              email_confirmation_code: this.$store.state.signup.props.confirmation_code,
              machine_id: this.$store.getters.getMachineId
            })

            setTimeout(() => {
                this.processing = false
            }, 1000);

        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Session/Signup/Step1.vue